import { Box, Button, IconButton } from "@mui/material"
import { useStyles } from "./styles"
import { InputModel } from "../../../../../../../../utils/types"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useCatalogStore } from "../../context"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { ObjectGeneric, onChange } from "../../../../../../../../utils/types/generals"
import { LevelEnum, OptionValueType } from "../../enums"
import { icons } from "../../../../../../../../utils/icons"
import { useTranslation } from "react-i18next"
import Papa from 'papaparse';
import { v4 as uuidv4 } from "uuid";
import { DraggableItem } from "../draggableItem/types"
import { isRequired } from "../../../../../../../../utils/validate/validate"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { SnackSimple } from "../../../../../../../../components"
import { Types } from "../../../../../../../../utils/enums"


const FormLevel = ({ parentId, hasChild, level, id: itemId, subCatalogId }: { subCatalogId?: number; id: string, level: number; parentId: string | null, hasChild: boolean }) => {
    const { subValueTypes, subCatalog, addItem, collapseItemAndChildren, editItem, editItemSubCatalog, setCatalogRoot, selectedItem, clearChildren, setSelectedItem } = useCatalogStore();
    const { t } = useTranslation()
    const styles = useStyles()
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const [allErrors, setAllErrors] = useState<ObjectGeneric>({})
    const [newSelectedItem, setNewSelectedItem] = useState<DraggableItem | null>(null);
    const [data, setData] = useState<ObjectGeneric>({
        subValue: null,
        /* typeSubValue: OptionValueType.VALUE,
        subCatalog: null, */
        typeSubValue: subCatalogId ? OptionValueType.SUB_CATALOG : OptionValueType.VALUE,
        subCatalog: subCatalogId ? subCatalogId : null,
    })
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void,
        cancel: () => void,
    }>({
        open: false,
        title: '',
        description: '',
        cancel: () => { },
        confirm: () => { },
    })

    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        type: Types.SUCCESS,
        message: ''
      })

    const closeSnackbar = () => { setOpenSnackbar(prev => ({ ...prev, open: false })) }

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const mainChange: onChange = useCallback((e, id): void => {
        const { name, value } = e?.target
        let body = { ...data }

        if (name == 'subValue') {
            if (isRequired(value)) {
                setAllErrors({ subValue: t('optionGroup.tags.errors.subValue') })
            } else {
                if ((value?.trim().length ?? 0) < 3) {
                    setAllErrors({ subValue: t('optionGroup.tags.errors.minLenght', { min: 3 }) })
                } else {
                    setAllErrors({ subValue: '' })
                }
            }
        }

        if (name == 'typeSubValue' && hasChild && data.typeSubValue !== value) {
            const prevValue = data.typeSubValue
            const pendingValue = value
            setData(prev => ({
                ...prev,
                typeSubValue: pendingValue,
            }))
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('optionGroup.modal.confirmation'),
                description: t('optionGroup.modal.changeSelection'),
                confirm: () => {
                    setAllErrors({})
                    clearChildren(parentId)
                    setData(prev => ({
                        ...prev,
                        typeSubValue: pendingValue,
                    }))
                    closeModal()
                },
                cancel: () => {
                    setData((prev) => ({
                        ...prev,
                        typeSubValue: prevValue,
                    }));
                    closeModal()
                }
            }))
            return
        }

        if (name == 'textField' && newSelectedItem?.children.length && value) {
            const prevValue = data.textField
            const pendingValue = value
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('optionGroup.modal.confirmation'),
                description: t('optionGroup.modal.changeTextInputOption'),
                confirm: () => {
                    setData(prev => ({
                        ...prev,
                        textField: pendingValue,
                    }))
                    closeModal()
                },
                cancel: () => {
                    setData((prev) => ({
                        ...prev,
                        textField: prevValue,
                    }));
                    closeModal()
                }
            }))
            return
        }

        if (name == 'subCatalog' && hasChild) {
            const prevValue = data.subCatalog
            const pendingValue = value
            setData(prev => ({
                ...prev,
                subCatalog: pendingValue,
            }))
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('optionGroup.modal.confirmation'),
                description: t('optionGroup.modal.changeCatalogSelection'),
                confirm: () => {
                    setAllErrors({})
                    clearChildren(parentId)
                    setData(prev => ({
                        ...prev,
                        subCatalog: pendingValue,
                    }))
                    //Asignar nuevo catalogo al item
                    editItemSubCatalog(itemId, pendingValue);
                    if (level == LevelEnum.CATEGORY) {
                        setCatalogRoot(pendingValue)
                    }
                    closeModal()
                },
                cancel: () => {
                    setData((prev) => ({
                        ...prev,
                        subCatalog: prevValue,
                    }));
                    closeModal()
                }
            }))
            return
        }

        if (name == 'subCatalog' && !hasChild && value) {
            //Edita ritem para asignar el catalogo
            editItemSubCatalog(itemId, value.value);
        }

        if (name == 'subCatalog' && !hasChild) {
            //Edita ritem para asignar el catalogo
            if (level == LevelEnum.CATEGORY) {
                setCatalogRoot(value.value)
            }
        }

        if (name == 'typeSubValue' && !hasChild) {
            setAllErrors({})
            setData({
                subValue: null,
                typeSubValue: value,
                subCatalog: null,
            });
            return;
        }
        body = {
            ...body,
            [name]: value,
        }
        setData(body)
    }, [hasChild, clearChildren, closeModal, parentId, data, t]);

    const handleCSVImport = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const arrayBuffer = e.target?.result as ArrayBuffer;
                if (!arrayBuffer) return;

                const bytes = new Uint8Array(arrayBuffer);

                // 1) Detectar BOM UTF-8 (EF BB BF)
                const hasUtf8Bom = bytes.length >= 3 &&
                    bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf;

                // Helper: decodificar con TextDecoder
                const decode = (encoding: string) => {
                    try {
                        return new TextDecoder(encoding).decode(bytes);
                    } catch (err) {
                        console.warn("TextDecoder no soporta encoding:", encoding, err);
                        return null;
                    }
                };

                // 2) Intentar UTF-8 inicialmente (si BOM => preferir)
                let text = hasUtf8Bom ? decode("utf-8") || "" : decode("utf-8") || "";

                // 3) Detectar mojibake común (ejemplos: Ã±, Ã¡, Ã©, Â¿, Â¡)
                const mojibakeRegex = /Ã[¡-ñ]|Â[¡¿]|�/; // patrón simple para caracteres mojibake o replacement char
                const looksLikeMojibake = mojibakeRegex.test(text);

                if (looksLikeMojibake) {
                    // 4) Reintentar con windows-1252 / iso-8859-1
                    const alt = decode("windows-1252") || decode("iso-8859-1") || "";
                    if (alt && !mojibakeRegex.test(alt)) {
                        text = alt;
                    } else {
                        // si sigue raro, intenta ambos y elige el que parezca mejor (más vocales acentuadas / ñ)
                        const utf8Count = (text.match(/[áéíóúÁÉÍÓÚñÑ]/g) || []).length;
                        const altCount = (alt.match(/[áéíóúÁÉÍÓÚñÑ]/g) || []).length;
                        if (altCount > utf8Count) text = alt;
                    }
                }

                // 5) Parsear con PapaParse a partir del texto decodificado
                Papa.parse<string[]>(text, {
                    header: false,
                    skipEmptyLines: true,
                    complete: (results) => {
                        const flatValues = (results.data as string[][]).flat();

                        // Filtrar vacíos
                        const filtered = flatValues.filter((v) => v && v.trim() !== "");

                        // Mapear a tu estructura
                        const importedValues = filtered.map((value) => ({
                            id: uuidv4(),
                            label: value,
                            children: [],
                            expand: false,
                            level: level,
                            isEditable: true
                        }));
                        addItem(parentId, importedValues);

                    },
                    error: (err: Error) => {
                        console.error("Papa parse error:", err);
                    },
                });
            } catch (err) {
                console.error("Error leyendo/decodificando CSV:", err);
            }
        };

        // Leemos como ArrayBuffer para permitir TextDecoder con distintos encodings
        reader.readAsArrayBuffer(file);

        // permitir seleccionar el mismo archivo después
        event.target.value = "";
    };

    const handleSubmit = useCallback(() => {
        if (newSelectedItem) {
            editItem(newSelectedItem.id, data.subValue, data.textField);
            setSelectedItem(level == LevelEnum.CATEGORY ? 'root' : itemId, null)
            if (data.textField && newSelectedItem.children.length) {
                clearChildren(newSelectedItem.id)
            }
            if (data.textField) {
                collapseItemAndChildren(newSelectedItem.id)
            }
        } else {
            const newItem: DraggableItem = {
                id: uuidv4(),
                label: data.subValue,
                children: [],
                expand: false,
                level: level,
                isEditable: true,
                textInput: data.textField
            };
            addItem(parentId, newItem);
        }

        setData({
            subValue: null,
            typeSubValue: OptionValueType.VALUE,
            subCatalog: null,
        });
    }, [data.subValue, data.textField, parentId, selectedItem, addItem, editItem, newSelectedItem]);

    const handleSubmitSubCatalog = useCallback(() => {

        const catalogKey = data.subCatalog.value;
        const predefined = subCatalog.find(cat => cat.value === catalogKey)?.children || [];

        if (predefined.length > 0 && !hasChild) {
            const newItems: DraggableItem[] = predefined.map(item => ({
                id: uuidv4(),
                itemSubCatalogId: item.id,
                label: item.name,
                children: [],
                expand: false,
                level: level,
                isEditable: false,
            }));

            addItem(parentId, newItems);

            if(level==LevelEnum.CATEGORY && predefined.length<2){
                setOpenSnackbar(prev => ({ ...prev, open: true, message:t('optionGroup.snackbar.selectOneTemplate'), type: Types.INFO }))
            }
        }

    }, [data.subCatalog, parentId, addItem, hasChild]);

    const mainInput = useMemo<{ [key: string]: InputModel }>(() => {
        const baseInputs: { [key: string]: InputModel } = {
            typeSubValue: {
                label: "optionGroup.tags.title.subValueType",
                translate: true,
                name: "typeSubValue",
                type: "select",
                items: subValueTypes,
                value: null/* data.typeSubValue */,
                rest: { placeholder: "Tipo de plantilla" },
                size: { xl: 3, lg: 3, md: data.typeSubValue === OptionValueType.VALUE ? 12 : 6, sm: 12, xs: 12 },
            },
        };

        if (data.typeSubValue === OptionValueType.VALUE) {
            baseInputs.subValue = {
                label: "optionGroup.tags.title.subValue",
                translate: true,
                name: "subValue",
                type: "text",
                value: data.subValue,
                rest: { placeholder: "Ingrese el nombre del subvalor" },
                validate: { required: true },
                size: { xl: 3, lg: 3, md: 12, sm: 12, xs: 12 },
            };
            baseInputs.textField = {
                label: 'catalog.inputs.textField',
                translate: true,
                name: 'textField',
                type: 'check',
                //items: priorities,
                value: null,
                size: { xl: 6, lg: 6, md: 12, sm: 12, xs: 12 },
                wrapChildren: ({ children }) => (
                    <Box sx={styles.containerChildren}>
                        <Box sx={styles.containerAdd}>
                            <Box sx={styles.children}>{children}</Box>
                            <Box sx={styles.optionsAddText((data.subValue?.trim().length ?? 0) < 3)}>
                                <IconButton
                                    className="add"
                                    onClick={handleSubmit}
                                    disabled={(data.subValue?.trim().length ?? 0) < 3}
                                >
                                    {icons("add")}
                                </IconButton>
                            </Box>
                        </Box>

                        <Button sx={styles.subtitle} onClick={() => fileInputRef.current?.click()}>
                            {t("general.importCsv")}
                        </Button>
                    </Box>
                ),
            }
        } else {
            baseInputs.subCatalog = {
                label: "optionGroup.tags.title.subCatalog",
                translate: true,
                name: "subCatalog",
                type: "select-search",
                items: subCatalog.map((catalog) => ({
                    label: catalog.label,
                    value: catalog.value,
                })),
                value: data.subCatalog,
                rest: { placeholder: "Seleccione un subcatálogo" },
                validate: { required: true },
                size: { xl: 9, lg: 9, md: 6, sm: 12, xs: 12 },
                wrapChildren: ({ children }) => (
                    <Box sx={styles.containerChildrenSelect}>
                        <Box sx={styles.childrenSelect}>{children}</Box>
                        <Box sx={styles.optionsAdd(!data.subCatalog)}>
                            <IconButton
                                className="add"
                                onClick={handleSubmitSubCatalog}
                                disabled={!data.subCatalog}
                            >
                                {icons("add")}
                            </IconButton>
                        </Box>
                    </Box>
                ),
            };
        }

        return baseInputs;
    }, [data.typeSubValue, data.textField, data.subValue, data.subCatalog, subValueTypes, subCatalog, t, handleSubmit, hasChild]);

    const mainInputTypeSubvalue = useMemo<{ [key: string]: InputModel }>(() => ({
        typeSubValue: {
            label: "optionGroup.tags.title.subValueType",
            translate: true,
            name: "typeSubValue",
            type: "select",
            items: subValueTypes,
            value: null,
            rest: { placeholder: "Tipo de plantilla" },
        },
    }), [data.typeSubValue, subValueTypes]);

    const mainInputSubValue = useMemo<{ [key: string]: InputModel }>(() => ({
        subValue: {
            label: "optionGroup.tags.title.subValue",
            translate: true,
            name: "subValue",
            type: "text",
            value: data.subValue,
            rest: { placeholder: "Ingrese el nombre del subvalor" },
            validate: { required: true },
        }
    }), [data.subValue, t, handleSubmit]);

    const mainInputTextField = useMemo<{ [key: string]: InputModel }>(() => ({
        textField: {
            label: 'catalog.inputs.textField',
            translate: true,
            name: 'textField',
            type: 'check',
            //items: priorities,
            value: null,
            size: { xl: 4.5, lg: 4.5, md: 12, sm: 12, xs: 12 },
            wrapChildren: ({ children }) => (
                <Box sx={styles.containerChildrenText}>
                    <Box sx={styles.containerAdd}>
                        <Box sx={styles.children}>{children}</Box>
                        <Box sx={styles.optionsAddText((data.subValue?.trim().length ?? 0) < 3)}>
                            <IconButton
                                className="add"
                                onClick={handleSubmit}
                                disabled={(data.subValue?.trim().length ?? 0) < 3}
                            >
                                {icons("add")}
                            </IconButton>
                        </Box>
                    </Box>
                </Box>
            ),
        }
    }), [data.subValue, data.textField, t, handleSubmit]);

    const mainInputSubCatalog = useMemo<{ [key: string]: InputModel }>(() => ({
        subCatalog: {
            label: "optionGroup.tags.title.subCatalog",
            translate: true,
            name: "subCatalog",
            type: "select-search",
            items: subCatalog.map((catalog) => ({
                label: catalog.label,
                value: catalog.value,
            })),
            value: data.subCatalog,
            rest: { placeholder: "Seleccione un subcatálogo" },
            validate: { required: true },
            wrapChildren: ({ children }) => (
                <Box sx={styles.containerChildrenSelect}>
                    <Box sx={styles.childrenSelect}>{children}</Box>
                    <Box sx={styles.optionsAdd(!data.subCatalog)}>
                        <IconButton
                            className="add"
                            onClick={handleSubmitSubCatalog}
                            disabled={!data.subCatalog}
                        >
                            {icons("add")}
                        </IconButton>
                    </Box>
                </Box>
            ),
        }

    }), [data.subCatalog, subCatalog, t, handleSubmitSubCatalog, hasChild]);

    useEffect(() => {

        const foundSelectedItem = selectedItem[level == LevelEnum.CATEGORY ? 'root' : itemId];
        setNewSelectedItem(foundSelectedItem);

        if (foundSelectedItem) {
            setData(prev => ({
                ...prev,
                subValue: foundSelectedItem.label,
                textField: foundSelectedItem.textInput
            }))
        } else {
            setData(prev => ({
                ...prev,
                subValue: null,
            }))
        }

    }, [selectedItem[level == LevelEnum.CATEGORY ? 'root' : itemId]]);


    return (
        <Box sx={styles.container}>
            {level == LevelEnum.CATEGORY && <DinamicForm spacing={{ column: 3, row: 3 }} input={Object.values(mainInput)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />}

            {(level > LevelEnum.CATEGORY && data.typeSubValue === OptionValueType.VALUE) &&
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputType}>
                        <DinamicForm input={Object.values(mainInputTypeSubvalue)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                    <Box sx={styles.inputySubValue}>
                        <DinamicForm input={Object.values(mainInputSubValue)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                    <Box sx={styles.inputText}>
                        <DinamicForm input={Object.values(mainInputTextField)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>

                    <Box sx={styles.inputImport}>
                        <Button sx={styles.subtitleText} onClick={() => fileInputRef.current?.click()}>
                            {t("general.importCsv")}
                        </Button>
                    </Box>
                </Box>
            }

            {(level > LevelEnum.CATEGORY && data.typeSubValue === OptionValueType.SUB_CATALOG) &&
                <Box sx={styles.inputContainer}>
                    <Box sx={styles.inputType}>
                        <DinamicForm input={Object.values(mainInputTypeSubvalue)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                    <Box sx={styles.inputSubcatalog}>
                        <DinamicForm input={Object.values(mainInputSubCatalog)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                    </Box>
                </Box>
            }

            <input
                ref={fileInputRef}
                type="file"
                accept=".csv"
                style={{ display: "none" }}
                onChange={handleCSVImport}
            />

            <SimpleModal
                open={!!modal.open}
                next={modal.confirm}
                back={modal.cancel}
                close={closeModal}
                description={modal.description}
                buttonText={t('general.yes')}
                cancelText={t('general.no')}
                title={modal.title}
                loadingButton={false}
            />

            <SnackSimple 
                close={closeSnackbar} 
                open={openSnackbar.open} 
                type={openSnackbar.type} 
                message={openSnackbar.message} 
            />
        </Box>
    )
}

export default FormLevel
